import { useCallback, useEffect, useRef, useState } from 'react';
import { kioskSupabase } from '../../lib/supabase';

declare global {
  interface Window { MP_DEVICE_SESSION_ID?: string }
}

const readToken = () => new URLSearchParams(window.location.search).get('t')?.trim() || '';

export default function InscripcionPagoPage() {
  const [message, setMessage] = useState('Preparando tu pago seguro…');
  const [error, setError] = useState('');
  const running = useRef(false);

  const continuePayment = useCallback(async () => {
    if (running.current) return;
    const token = readToken();
    if (!token) { setError('El enlace de inscripción no es válido.'); return; }
    running.current = true;
    setError('');
    setMessage('Validando el dispositivo…');
    try {
      if (!document.querySelector('script[data-mp-security]')) {
        const script = document.createElement('script');
        script.src = 'https://www.mercadopago.com/v2/security.js';
        script.dataset.mpSecurity = 'true';
        script.setAttribute('view', 'checkout');
        document.head.appendChild(script);
      }
      for (let attempt = 0; attempt < 20 && !window.MP_DEVICE_SESSION_ID; attempt++) {
        await new Promise(resolve => window.setTimeout(resolve, 150));
      }
      setMessage('Conectando con Mercado Pago…');
      const { data, error: invokeError } = await kioskSupabase.functions.invoke('mercadopago-subscription-start', {
        body: { action: 'continue', checkout_token: token, device_id: window.MP_DEVICE_SESSION_ID || '' },
      });
      if (invokeError) {
        let detail = '';
        try { detail = String((await invokeError.context?.clone().json())?.error || ''); } catch { /* response was not JSON */ }
        throw new Error(detail || invokeError.message);
      }
      const destination = String(data?.init_point || '');
      if (!destination) throw new Error(String(data?.error || 'No pudimos abrir el pago.'));
      window.location.replace(destination);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'No pudimos iniciar el pago.');
      setMessage('');
      running.current = false;
    }
  }, []);

  useEffect(() => { void continuePayment(); }, [continuePayment]);

  return <main className="min-h-screen bg-[#f5f4f1] p-5 grid place-items-center text-slate-900">
    <section className="w-full max-w-md bg-white border rounded-3xl shadow-sm p-8 text-center">
      <div className="mx-auto w-16 h-16 rounded-full bg-[#e7eee3] text-[#314a25] grid place-items-center text-3xl">
        <i className={error ? 'ri-error-warning-line' : 'ri-shield-check-line'} />
      </div>
      <h1 className="text-2xl font-extrabold mt-5">Inscripción Mowe</h1>
      {message && <><i className="ri-loader-4-line animate-spin inline-block text-3xl text-[#314a25] mt-6"/><p className="mt-3 text-gray-600">{message}</p></>}
      {error && <div className="mt-6"><p className="p-4 rounded-xl bg-red-50 border border-red-200 text-red-700">{error}</p><button onClick={() => void continuePayment()} className="mt-4 w-full px-5 py-3 rounded-xl bg-[#314a25] text-white font-bold">Intentar nuevamente</button></div>}
      <p className="text-xs text-gray-400 mt-6">No cierres esta ventana mientras conectamos el pago.</p>
    </section>
  </main>;
}
